// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";

export const useAccountBalanceCredits = () =>
    useAppSelector(state => toToolkitApplicationState(state).bunzl.pages.accountBalance.accountBalance?.credits) ?? [];
export const useIsAccountBalanceLoading = () =>
    useAppSelector(state => toToolkitApplicationState(state).bunzl.pages.accountBalance.isLoading);

export default () => useAppSelector(state => toToolkitApplicationState(state).bunzl.pages.accountBalance);
